// Landing page entry point
import './shared/utils/reload-on-stale-chunks.js';
import './pull-to-refresh.js';
import { registerServiceWorkerWithCOI } from './shared/utils/coi.js';

// Register Service Worker for PWA + cross-origin isolation (multi-threaded WASM)
window.addEventListener('load', registerServiceWorkerWithCOI);

const loader = document.getElementById('page-loader');

// Function to hide loader
function hideLoader() {
    if (loader) {
        loader.classList.add('hidden');
    }
}

// Hide page loader after page is fully loaded
window.addEventListener('load', hideLoader);

// Handle browser back/forward cache (bfcache)
window.addEventListener('pageshow', function (event) {
    // If page is loaded from cache, hide the loader
    if (event.persisted) {
        hideLoader();
    }
});

// Show loader when clicking navigation links
document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('a[href="player.html"]');

    navLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            // Show loader immediately
            if (loader) {
                loader.classList.remove('hidden');
            }
            // Let the browser navigate naturally (don't preventDefault)
        });
    });

    // Mobile Menu Logic
    const mobileBtn = document.querySelector('.mobile-menu-btn');
    const navLinksContainer = document.querySelector('.nav-links');
    const overlay = document.querySelector('.mobile-menu-overlay');

    if (mobileBtn && navLinksContainer) {
        function toggleMenu() {
            const isExpanded = mobileBtn.getAttribute('aria-expanded') === 'true';
            mobileBtn.setAttribute('aria-expanded', !isExpanded);
            navLinksContainer.classList.toggle('active');
            mobileBtn.classList.toggle('active');
            if (overlay) overlay.classList.toggle('active');
            document.body.classList.toggle('no-scroll');
        }

        mobileBtn.addEventListener('click', toggleMenu);
        if (overlay) overlay.addEventListener('click', toggleMenu);

        // Close menu when clicking a link
        navLinksContainer.querySelectorAll('a, button').forEach(link => {
            link.addEventListener('click', () => {
                if (navLinksContainer.classList.contains('active')) {
                    toggleMenu();
                }
            });
        });
    }
    // Hero Video Animation
    const heroVideo = document.querySelector('.hero-video');
    const heroSection = document.getElementById('hero');

    if (heroVideo && heroSection) {
        // Function to trigger animation
        const triggerAnimation = () => {
            heroSection.classList.add('video-loaded');
        };

        // If video is already playing (cached or fast load)
        if (heroVideo.currentTime > 0 && !heroVideo.paused && !heroVideo.ended && heroVideo.readyState > 2) {
            triggerAnimation();
        } else {
            // Wait for play event
            heroVideo.addEventListener('play', triggerAnimation);
            // Fallback: also check timeupdate in case play event fired before listener
            heroVideo.addEventListener('timeupdate', () => {
                if (heroVideo.currentTime > 0.5) triggerAnimation(); // Small buffer
            }, { once: true });
        }
    }
});
